module.exports = {"430602001":"岳阳楼街道","430602002":"三眼桥街道","430602003":"吕仙亭街道","430602004":"金鹗山街道","430602005":"东茅岭街道","430602006":"五里牌街道","430602007":"望岳路街道","430602008":"城陵矶街道","430602009":"枫桥湖街道","430602010":"奇家岭街道","430602011":"洞庭街道","430602012":"洛王街道","430602013":"南湖街道","430602014":"站前街道","430602015":"王家河街道","430602016":"求索街道","430602017":"湖滨街道","430602018":"龙山街道","430602019":"月山街道","430602100":"西塘镇","430602201":"郭镇乡","430602203":"康王乡","430602402":"经济技术开发区通海路管理处","430602406":"金凤桥管理处","430602407":"木里港管理处"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430602.json
// module id = 1860
// module chunks = 0